export const getProgramListForUser = () => {
    if (typeof window === "undefined" || !localStorage) {
        return [] // Return a safe fallback
    }
    const user = JSON.parse(localStorage.getItem("user"))
    const programList = user?.programListForUser || []
    return programList
        .filter(item => item.programId !== 2)
        .map(item => ({
            id: item.programId,
            programName: item.programName,
            programDuration: item?.programDuration || 0,
        }))
}

export const getSelectedProgram = () => {
    if (typeof window === "undefined" || !localStorage) {
        return {} // Return a safe fallback
    }
    const selectedProgram = JSON.parse(localStorage.getItem("selectedProgram"))
    return selectedProgram || {}
}
